import React from 'react';
import { useNavigate, useOutletContext, Link } from 'react-router-dom';
import { IoIosArrowBack } from 'react-icons/io';

const AboutPage = () => {
  const navigate = useNavigate();
  const userData = useOutletContext();

  const handleBack = () => navigate(-1);

  return (
    <div>
      <div className="mb-6 flex items-center gap-3">
        <button onClick={handleBack} className="flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-brand-700">
          <IoIosArrowBack /> Go Back
        </button>
        <h2 className="text-lg font-bold text-gray-900">About</h2>
      </div>

      {!userData || !userData.firstName ? (
        <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-gray-300 py-16 text-center">
          <p className="text-gray-500">Log in to view your profile information.</p>
          <Link to="/login" className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700">
            Go to login
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="rounded-xl border border-gray-200 bg-white p-5">
            <h3 className="mb-3 text-sm font-bold text-gray-900">Personal Information</h3>
            <ul className="space-y-1.5 text-sm text-gray-600">
              <li><strong className="text-gray-900">Name:</strong> {userData.firstName} {userData.lastName}</li>
              <li><strong className="text-gray-900">Gender:</strong> {userData.gender}</li>
              <li><strong className="text-gray-900">Date of Birth:</strong> {userData.birthDate}</li>
            </ul>
          </div>
          <div className="rounded-xl border border-gray-200 bg-white p-5">
            <h3 className="mb-3 text-sm font-bold text-gray-900">Contact Information</h3>
            <ul className="space-y-1.5 text-sm text-gray-600">
              <li><strong className="text-gray-900">Email:</strong> {userData.email}</li>
              <li><strong className="text-gray-900">Phone:</strong> {userData.phone}</li>
            </ul>
          </div>
          {userData.address && (
            <div className="rounded-xl border border-gray-200 bg-white p-5 sm:col-span-2">
              <h3 className="mb-3 text-sm font-bold text-gray-900">Address</h3>
              <ul className="space-y-1.5 text-sm text-gray-600">
                <li><strong className="text-gray-900">Street Address:</strong> {userData.address.address}</li>
                <li><strong className="text-gray-900">City:</strong> {userData.address.city}</li>
                <li><strong className="text-gray-900">State:</strong> {userData.address.state}</li>
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AboutPage;
